import React from 'react';

/**
 * Higher order component to wrap a step with pricing logic.
 *
 * @param WrappedComponent the component to wrap
 */
function withPricing(WrappedComponent) {
	
	return class extends React.Component {
		
		/**
		 * Constructor sets instance variables and binds functions.
		 *
		 * @param props the properties
		 * @param props.userInfo the signed-in user info
		 * @param props.gearOrder the GEAR order
		 */
		constructor(props) {
			super(props);
			
			this.state = {
				slowFetch: false
			};
			
			this.fetchCount = 0;
			this.fetchData = {};
			
			this.updateFetchElapsed = this.updateFetchElapsed.bind(this);
			this.getRequisitionPrice = this.getRequisitionPrice.bind(this);
		}
		
		/**
		 * Updates the elapsed time for a single pricing fetch.
		 *
		 * @param fetchKey the fetch key (requisitionID and billing option name)
		 */	
		updateFetchElapsed(fetchKey) {
			let elapsed = (new Date() - this.fetchData[fetchKey].start) / 1000;
			this.fetchData[fetchKey].elapsed = elapsed;
			if (elapsed > 30 && !this.state.slowFetch) {
				this.setState({
					slowFetch: true
				});
			}
	    }
		
		/**
		 * Gets the price for a requisition and billing option.
		 *
		 * @param requisitionId the GEAR requisition ID
		 * @param billingOption the billing option name
		 */
		getRequisitionPrice(requisitionId, billingOptionName) {
			if (billingOptionName === process.env.REACT_APP_BILLING_PHYSICIAN_ACCOUNT_VALUE) {
				return Promise.resolve(
					{
						gearRequisitionId: requisitionId,
						billingMethod: billingOptionName,
						price: 0,
						placeholder: true,
						error: false
					}
				);
			}

			this.fetchCount++;
			const fetchKey = requisitionId + "_" + billingOptionName;
			this.fetchData[fetchKey] = {
				start: new Date(),
				elapsed: 0,
				timer: window.setInterval(this.updateFetchElapsed, 1000, fetchKey)
			};
			return fetch(process.env.REACT_APP_GEAR_REST_URL+'/api/applied-price?gearReqId='+requisitionId+'&billingMethod='+billingOptionName, {
				method: 'GET',
				credentials: 'include',
				mode: 'cors',
				timeout:1000,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				}
			})
			.then(response => {
				if (response.ok) {
					return response.json();
				} else {
					return Promise.reject(new Error('An unexpected error has occurred. Please call us at 800-522-4762.'));
				}
			})
			.then(json => {
				return Promise.resolve(json);
			})
			.catch(error => {
				return Promise.reject(error);
			})
			.finally(() => {
				window.clearInterval(this.fetchData[fetchKey].timer);
				delete this.fetchData[fetchKey];
				this.fetchCount--;
				if (this.fetchCount === 0 && this.state.slowFetch) {
					this.setState({
						slowFetch: false
					});
				}
			});
		}
		
		render() {
			return (
				<WrappedComponent
					getRequisitionPrice={this.getRequisitionPrice}
					slowFetch={this.state.slowFetch}
					{...this.props} />
			);
		}
	};
}

export default withPricing;
